import { Icon } from '../../Elements'
import { useNavigate } from 'react-router-dom'

const PageHeader = ({ className, title, path }: PageHeaderInterface) => {
  const navigate = useNavigate()
  return (
    <>
      <div
        className={`${className ?? ''}  px-4 
         border-b border-b-disable py-2 shadow-sm top-12 sticky bg-primaryDefault z-50`}
      >
        <Icon
          icon='rayteb-back'
          className='w-5 h-5 text-xl absolute'
          onClick={() => path ? navigate(path) : navigate(-1)}
        />

        <div className='text-center'>
          <h1>{title}</h1>
        </div>
      </div>
    </>
  )
}

export default PageHeader
